export enum IdnowDocumentType {
  ID = 'ID',
  IBAN = 'IBAN',
  CHEQUE = 'CHEQUE',
  TAX_SHEET = 'TAX_SHEET',
  PAY_SLIP = 'PAY_SLIP',
  ADDRESS_PROOF = 'ADDRESS_PROOF',
  CREDIT_CARD = 'CREDIT_CARD',
  PORTRAIT = 'PORTRAIT',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  CAR_REGISTRATION = 'CAR_REGISTRATION',
  LIVENESS = 'LIVENESS',
  DATA = 'DATA',
}

export enum IdnowDocumentSubType {
  ID = 'ID',
  PASSPORT = 'PASSPORT',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  HEALTH_CARD = 'HEALTH_CARD',
  VISA = 'VISA',
  IBAN = 'IBAN',
  CHEQUE = 'CHEQUE',
  ADDRESS = 'ADDRESS',
  TAX = 'TAX',
  PAY = 'PAY',
  CREDIT_CARD = 'CREDIT_CARD',
  PORTRAIT = 'PORTRAIT',
  COMPANY = 'COMPANY',
  COMPANY_REG_CERT = 'COMPANY_REG_CERT',
  CAR_REGISTRATION = 'CAR_REGISTRATION',
  LIVENESS = 'LIVENESS',
  DATA = 'DATA',
  UNKNOWN = 'UNKNOWN',
}

// Idnow does not have consistency in their document titles
export enum IdnowDocumentTitle {
  HEALTH_CARD = 'Health card',
  IBAN = 'IBAN',
  ID = 'ID',
  PASSPORT = 'Passport',
  RESIDENCE_PERMIT = 'Residence permit',
}

export enum IdnowDocumentPart {
  RECTO = 'RECTO',
  VERSO = 'VERSO',
}

export enum IdnowDocumentExtraField {
  MRZ_LINE_1 = 'MRZ_LINE_1',
  MRZ_LINE_2 = 'MRZ_LINE_2',
  MRZ_LINE_3 = 'MRZ_LINE_3',
  REMARKS_1 = 'REMARKS_1',
}
